import React from 'react';
import { Link } from 'react-router-dom'
import Layout from '../../components/Layout';
import strings from "./../../components/Language";

import SliderHome from "./Slider/index";
import Menu from "./Menu";
import DCABot from "./ListItems/DCABot";
import BOLLBot from "./ListItems/BOLLBot";

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import "./home.scss";

import ArrowForword from './../../assets/images/icons/arrow_forword.svg';
import notifications from './../../assets/images/menu/notification.png';

import { getToken, storeUserData, getUserData } from './../../components/Util';
import AIBot from './ListItems/AIBot';
import BOLLBotAll from './ListItems/BOLLBotAll';
import AIBotAll from './ListItems/AIBotAll';
import SwipeableViews from 'react-swipeable-views';

// import { toast } from 'react-toastify';

class HomeScreen extends React.Component {
	constructor(props) {
		super(props);
		var headerData = (this.props && this.props.data) ? this.props.data : {};
		var headerTitle = (this.props && this.props.data && this.props.data.title) ? this.props.data.title : "";
		let savedTabValue = sessionStorage.getItem('homeTabValue'); let savedSubTabCTS = sessionStorage.getItem('homeSubTabCTS'); let savedSubTabAI = sessionStorage.getItem('homeSubTabAI'); this.state = { headerData: headerData, headerTitle: headerTitle, user_data: {}, tabValue: savedTabValue !== null ? parseInt(savedTabValue) : 0, subTabCTS: savedSubTabCTS !== null ? parseInt(savedSubTabCTS) : 0, subTabAI: savedSubTabAI !== null ? parseInt(savedSubTabAI) : 0 }
		this.handleChange = this.handleChange.bind(this);
	}

	handleChange(event, newValue) { const self = this; sessionStorage.setItem('homeTabValue', newValue); self.setState({ tabValue: newValue }); };

	async componentDidMount() {
		var token = await getToken();
		if (token) {
			await storeUserData(token);
			setTimeout(() => {
				var user_data = getUserData();
				this.setState({ access_token: token, user_data: (user_data && user_data.data) ? user_data.data : {} });
			});
		}
	}

	render() {
		const fuelBalance = (this.state.user_data && this.state.user_data.credit && this.state.user_data.credit.usdt != null)
			? parseFloat(this.state.user_data.credit.usdt)
			: null;
		const showLowFuelNotice = fuelBalance != null && fuelBalance < 10;
		return (
			<Layout data={{ "title": strings.Home, is_logo: true }}>
				<div className="slider_class">
					<SliderHome />
				</div>
				<div className='border_'></div>
				{showLowFuelNotice ?
					<div className='low_fuel_notice'>
						<span>{strings.fuel_balance_is_insufficient}</span>
					</div>
					: null}
				<Link to="/announcement" className='flex-center announcement_strip' style={{ justifyContent: "space-between" }}>
					<div className='flex-center' style={{ flexDirection: "row" }}>
						<img className="" alt="Notifications" src={notifications} width={25} height={25} />
						<div style={{ marginLeft: 10 }}>
							<span style={{ fontSize: 14 }}>{strings.Latest_Announcement}</span>
						</div>
					</div>
					<div>
						<img src={ArrowForword} alt="ArrowForword" width={15} height={15}></img>
					</div>
				</Link>
				<div className='border_'></div>
				<div className="">
					<Menu />
				</div>
				<div className='border_'></div>
				<div className="">
					<Tabs
						value={this.state.tabValue}
						onChange={this.handleChange}
						variant="scrollable"
						scrollButtons="auto"
					>
						<Tab label="DCA" />
						<Tab label="CTS" />
						<Tab label="AI" />
					</Tabs>
					<SwipeableViews index={this.state.tabValue} onChangeIndex={(index) => this.handleChange(null, index)} style={{minHeight: "calc(50vh - 150px)"}}>
						<div role="tabpanel" hidden={this.state.tabValue !== 0}>
							{this.state.tabValue === 0 ?
								<div className="">
									<DCABot />
								</div>
								: null}
						</div>
						<div role="tabpanel" hidden={this.state.tabValue !== 1}>
							{this.state.tabValue === 1 ?
								<div>
									<Tabs
										value={this.state.subTabCTS}
										onChange={(_e, v) => { sessionStorage.setItem('homeSubTabCTS', v); this.setState({ subTabCTS: v }); }}
										variant="fullWidth"
										TabIndicatorProps={{ style: { backgroundColor: "#56ab2f" } }}
										style={{ minHeight: 36 }}
									>
										<Tab label="Active" style={{ minHeight: 36, fontSize: 12, color: "#fff" }} />
										<Tab label="All" style={{ minHeight: 36, fontSize: 12, color: "#fff" }} />
									</Tabs>
									{this.state.subTabCTS === 0 ? <BOLLBot /> : <BOLLBotAll />}
								</div>
								: null}
						</div>
						<div role="tabpanel" hidden={this.state.tabValue !== 2}>
							{this.state.tabValue === 2 ?
								<div>
									<Tabs
										value={this.state.subTabAI}
										onChange={(_e, v) => { sessionStorage.setItem('homeSubTabAI', v); this.setState({ subTabAI: v }); }}
										variant="fullWidth"
										TabIndicatorProps={{ style: { backgroundColor: "#56ab2f" } }}
										style={{ minHeight: 36 }}
									>
										<Tab label="Active" style={{ minHeight: 36, fontSize: 12, color: "#fff" }} />
										<Tab label="All" style={{ minHeight: 36, fontSize: 12, color: "#fff" }} />
									</Tabs>
									{this.state.subTabAI === 0 ? <AIBot /> : <AIBotAll />}
								</div>
								: null}
						</div>
					</SwipeableViews>

				</div>
			</Layout>
		);
	}
}

export default HomeScreen;
